"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _providers = require("../../../../toolkit/providers");

var _styling = require("../../../../toolkit/styling");

//
//  src/data/table/section/TableSectionHeader.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 4/1/2020.
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var _default = (0, _mobxReact.observer)(function (_ref) {
  var section = _ref.section;
  var header = section.config.header;

  if (typeof header === "function") {
    return header();
  }

  var styles = useStylesheet();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root)
  }, header);
});

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      textBlack = _useTheming.theme.textBlack,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        color: textBlack,
        fontSize: 12,
        fontFamily: fonts.bold,
        padding: "2px 25px",
        cursor: "default"
      }
    });
  }, [textBlack, fonts.bold]);
};